// Kopie z FofrLamaPOS (components/pos/IkonaStolu.jsx) — editor stolů je v pokladně i ve Správě OS
// (Správa → Provozovna → Stoly, 2026-10-20). Měň obojí stejně.
/**
 * Bistro stolek — vlastní ikona, protože lucide žádnou nemá.
 *
 * Jejich `Table` je tabulka (mřížka buněk), což by v pokladně četlo jako
 * „seznam", a `Armchair` je židle, ne stůl. Příbor zase znamená jídlo obecně
 * a na kartě fronty se tloukl s ikonou „na místě".
 *
 * Kreslí se na stejné mřížce jako lucide (24×24, stroke 2, kulaté konce),
 * takže vedle jejich ikon nevyčnívá.
 */
export default function IkonaStolu({ size = 16, strokeWidth = 2, style, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0, ...style }}
      {...rest}
    >
      {/* deska */}
      <ellipse cx="12" cy="8" rx="9" ry="3" />
      {/* sloupek */}
      <path d="M12 11v8" />
      {/* podstavec */}
      <path d="M8 19h8" />
    </svg>
  )
}

/**
 * Stůl se dvěma židlemi — ikona záložky Stoly v hlavičce.
 *
 * Stolek sám (výš) je na kartách objednávek „na místě"; v navigaci má být
 * vidět, že jde o stoly a místa k sezení. Stejná mřížka jako lucide.
 */
export function IkonaStoluZidli({ size = 16, strokeWidth = 2, style, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0, ...style }}
      {...rest}
    >
      {/* deska a nohy stolu */}
      <path d="M6 10h12" />
      <path d="M8 10v8" />
      <path d="M16 10v8" />
      {/* židle z boku: opěradlo a sedák */}
      <path d="M3 6v12" />
      <path d="M3 14h2.5" />
      <path d="M21 6v12" />
      <path d="M21 14h-2.5" />
    </svg>
  )
}
